import Button from 'Components/Base/Button'
import Typography from 'Components/Base/Typography'
import React from 'react'
import styled from 'styled-components'

interface props {
  handleNextStep: Function
}

export default function FormCover({ handleNextStep }: props) {
  return (
    <Container>
      <Card>
        <Header>Getting Ready for Your Consult</Header>
        <Para>
          Before your visit, we’d like to learn a bit about you. Filling out this short form helps us understand your health needs and prepare for
          your consultation.
        </Para>
        <Para>We’ll also use some basic information from your health plan to save you time and make sure everything is accurate.</Para>

        <ul>
          <Li>
            <b>Your information is private and secure.</b> It’s never shared with your employer.
          </Li>
          <Li>
            <b>Only our care team sees it.</b> We use it to give you the best care possible.
          </Li>
          <Li>
            <b>It’s quick and easy.</b> Just a few minutes now helps us support you better later.
          </Li>
        </ul>
        <Button text="Get Started" onClick={() => handleNextStep()} width={250} styles={{ marginTop: 40, fontWeight: 'bold' }} />
      </Card>
      <ImgColumn>
        <Image src="https://triacentral.blob.core.windows.net/dev-storage/portal/enrollment/Savings%201.png" />
        <Typography size={13}>*Tria Health’s Book of Business Average</Typography>
      </ImgColumn>
    </Container>
  )
}

const Container = styled.div`
  font-family: Raleway;
  display: flex;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  justify-content: space-between;
  margin-top: 50px;
  @media only screen and (max-width: 600px) {
    margin-top: 20px;
  }
`

const Card = styled.div`
  font-family: Raleway;
  max-width: 600px;
  height: fit-content;
  padding: 40px;
  text-align: left;
  @media only screen and (max-width: 600px) {
    margin-top: 20px;
    padding: 0px 20px 30px;
  }
`

const Header = styled.h1`
  font-weight: 700;
  font-size: 36px;
  margin-bottom: 20px;
`

const Para = styled.p`
  font-size: 18px;
  margin-bottom: 20px;
`

const Li = styled.li`
  font-size: 18px;
  margin-bottom: 10px;
`

const Image = styled.img`
  max-height: 530px;
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`
const ImgColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`
